import React, {useEffect, useState} from 'react';
import {coursesStore, monthIdx} from "../store/coursesStore";
import style from './unearnedRevenues.scss';
import {observer} from "mobx-react";
import {usersStore} from "../store/usersStore";
import {accountingApi} from "../api/accountingApi";
import {autorun} from "mobx";
import moment from "moment";
import {courseApi} from "../api/courseApi";
import {Button} from "../controls/button";
import {ConfirmationDialog} from "../controls/confirmationDialog";
import {logError} from "../errors/errorConsole";

// The table of unearned revenues will show all months between monthsToSkip + 1 and the month of the end of FY
const monthsToSkip = 72; //until Aug 2024 inclusive. Month idx 1 is Sept 2018 as per courseStore monthIdx() function. 

export const UnearnedRevenuesByPayer = observer(
  function UnearnedRevenuesByStudent(props) {
    const [purchasesToSgByCourseAndMonth, setPurchasesToSgByCourseAndMonth] = useState({});
    const [unearnedRevenueInAccounting, setUnearnedRevenueInAccounting] = useState();
    const [unearnedRevenueByCourseAndMonth, setUnearnedRevenueByCourseAndMonth] = useState({});
    const [consumedCreditByCourseAndMonth, setConsumedCreditByCourseAndMonth] = useState({});
    const [showOnlyMismatches, setShowOnlyMismatches] = React.useState(false);
    const [payerIds, setPayersIds] = useState([]);
    const [payerIdx, setPayersIdx] = useState(0);
    const [isShowReconciliationConfirmation, setShowReconciliationConfirmation] = useState(false);
    const [isCanceledAutomaticReconciliation, setCanceledAutomaticReconciliation] = useState(false);
    const [isSuggestSalesRealizationOfBalance, setSuggestSalesRealizationOfBalance] = useState(false);
    const [isSuggestTicketCreation, setSuggestTicketCreation] = useState(false);
    const [isSuggestSalesRealizationOfTrial, setSuggestSalesRealizationOfTrial] = useState(false);
    const [courseIdOfFreeTrial, setCourseIdOfFreeTrial] = useState(null);
    const [monthIdxOfTrial, setMonthIdxOfTrial] = useState(999);
    const [monthOfFirstPurchase, setMonthIdxOfFirstPurchase] = useState(999);
      
    
    const financialYearEndMillis = moment("2025-08-31T23:59:59.999+08:00"); //DON'T MOVE THIS OUT OF THE FUNCTION.
    const currMonth = monthIdx(financialYearEndMillis);
    const initialMonth = moment(financialYearEndMillis).subtract(currMonth, "months");
    const monthLabels = new Array(currMonth + 1)
      .fill("")
      .map((dum, idx) => moment(initialMonth).add(idx, "months").format("MM-YYYY"))
      .slice(monthsToSkip);
  
    useEffect(() => {
      loadAllPayerIds()
    }, []);
  
    useEffect(() => {
      autorun(async () => {
        if (coursesStore.coursesLoading) return;
  
        const payerId = payerIds[payerIdx];
        if (!payerId) return;
      
        const purchasesToSg = await courseApi.getPurchasesToSgForPayer(payerId);
        const courseIds = Array.from(new Set(purchasesToSg.map(p => p.courseId)));
        await Promise.all(courseIds.map(cId => coursesStore.reloadMeetingsOntoCourse(coursesStore.coursesById[cId])));
    
        const purchasesToSgByCourseAndMonth = {};
        const unearnedRevenueByCourseAndMonth = {};
        const consumedCreditByCourseAndMonth = {};
        courseIds.forEach((cId) => {
          const course = coursesStore.coursesById[cId];
          if (cId === "6157cd9a44fd446cfc8e5009") {
            return;
          }
        
          purchasesToSgByCourseAndMonth[cId] = course.purchasesToSgByMonth.purchasesToSgByPayerAndMonth[payerId];
          unearnedRevenueByCourseAndMonth[cId] = course.unearnedRevenueByPayerAndMonth[payerId];
          consumedCreditByCourseAndMonth[cId] = course.earnedRevenueByPayerAndMonth[payerId];
        });
        setPurchasesToSgByCourseAndMonth(purchasesToSgByCourseAndMonth);
        setUnearnedRevenueByCourseAndMonth(unearnedRevenueByCourseAndMonth);
        setConsumedCreditByCourseAndMonth(consumedCreditByCourseAndMonth);
        
        let [monthOfFirstPurchase, _] = findMonthForFirstPositiveValue(purchasesToSgByCourseAndMonth);
        let [monthOfFirstCreditConsumption, courseIdOfFreeTrial] = findMonthForFirstPositiveValue(consumedCreditByCourseAndMonth);
        
        console.log("courseIdOfFreeTrial", courseIdOfFreeTrial);
        
        if (monthOfFirstPurchase > monthOfFirstCreditConsumption) {
          setCourseIdOfFreeTrial(courseIdOfFreeTrial);
          setMonthIdxOfFirstPurchase(monthOfFirstPurchase);
          setMonthIdxOfTrial(monthOfFirstCreditConsumption);
          setSuggestSalesRealizationOfTrial(true);
        }
        
        loadAccounting()
      });
    }, [payerIds, payerIdx]);
  
  
    async function loadAllPayerIds() {
      const payerIds = (await courseApi.getPotentiallyActiveUsersInFinancialYear(financialYearEndMillis)).map(u => u.userId);
      // const payerIds = ["62496e64f4baa31932634a12", "6294117b2aa3243b8a7220e7", "6458447308f4f1986f7e4d18"];
      console.log("num of payers", payerIds.length);
      setPayersIds(payerIds);
    }
  
    async function loadAccounting() {
      setUnearnedRevenueInAccounting(await accountingApi.getUnrealizedSalesForPayer(payerIds[payerIdx], financialYearEndMillis.add(8, "hours").valueOf()));
    }
  

    return (
      <div>
        <label>
          <input type="checkbox" checked={showOnlyMismatches} onChange={ev => setShowOnlyMismatches(v => !v)}/>
          mismatches only 
        </label>
        <div className={style.mainTitle}>UNEARNED REVENUE BY PAYER - {payerIds.length} payers to go</div>
        <table className={style.unearnedRevTable}>
          <thead>
          <tr>
            <th/>
            {monthLabels.map(mthLabel => <>
              <th colSpan={3}>{mthLabel}</th>
            </>)}
          </tr>
          <tr>
            <th>Course</th>
            {monthLabels.map(label => <>
              <th>credit purchased</th>
              <th>credit consumed</th>
              <th>unearned rev</th>
            </>)}
            <th>In books</th>
          </tr>
          </thead>
          {(() => {
            const payerId = payerIds[payerIdx];
            if (!payerId) return;
            const payer = usersStore.getUserById(payerId);
            const courseIds = Object.keys(unearnedRevenueByCourseAndMonth);
            const creditXero = unearnedRevenueInAccounting;
            const creditOps = Object.values(unearnedRevenueByCourseAndMonth).map(crByMonth => crByMonth && crByMonth[currMonth] || []).flat().reduce((a, b) => a + b, 0);
            const mismatch = Math.abs(creditXero - creditOps) > 0.05 || creditOps !== creditOps; //highlight also if credit is NaN (because (NaN !== NaN) is true)
            console.log("purchasesToSgByCourseAndMonth", purchasesToSgByCourseAndMonth);
            console.log("consumedCreditByCourseAndMonth", consumedCreditByCourseAndMonth);
            const purchasesToSgSinceFeb = courseIds.some(cId => Object.entries(purchasesToSgByCourseAndMonth[cId] || {}).filter(([k, v]) => k >= monthsToSkip + 5).some(([k, v]) => typeof v !== "undefined"));
            const consumedCreditSinceFeb = courseIds.some(cId => Object.entries(consumedCreditByCourseAndMonth[cId] || {}).filter(([k, v]) => k >= monthsToSkip + 5).some(([k, cr]) => typeof cr === "number" && cr !== 0));
            if (!mismatch && typeof creditXero !== "undefined") {
              if (creditXero > 0.2 && !consumedCreditSinceFeb && !purchasesToSgSinceFeb) {
                if (creditXero <= 30 && !isSuggestSalesRealizationOfBalance) {
                  setSuggestSalesRealizationOfBalance(true)
                } else if (creditXero > 30 && !isSuggestTicketCreation) {
                  setSuggestTicketCreation(true)
                }
              } else if (!isShowReconciliationConfirmation && !isCanceledAutomaticReconciliation) {
                setShowReconciliationConfirmation(true);
              }
            }
            return (<>
              <tr className={style.payer}>
                <td colSpan={999}>{payer?.name} - {payer?._id}</td>
              </tr>
              {courseIds.map((cId, idx) => {
                const creditSpentPerMonth = consumedCreditByCourseAndMonth[cId] || {};
                const course = coursesStore.coursesById[cId];
                return (
                <tr>
                  <td>{course?.name}</td>
                  {monthLabels.map((label, idx) => {
                    const month = idx + monthsToSkip;
                    return <>
                      <td style={{backgroundColor: "f0f0f0"}} className={style.numeric}>
                        {purchasesToSgByCourseAndMonth[cId] && purchasesToSgByCourseAndMonth[cId][month]?.toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) || ""}
                      </td>
                      <td style={{backgroundColor: "e0e0e0"}} className={style.numeric}>
                        {creditSpentPerMonth[month]?.toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) || ""}
                      </td>
                      <td style={{backgroundColor: "d0d0d0"}} className={style.numeric}>
                        {unearnedRevenueByCourseAndMonth[cId] && unearnedRevenueByCourseAndMonth[cId][month]?.toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                    </>
                  })}
                  {(idx === 0) && <td className={style.numeric} style={mismatch ? {color: "red", fontWeight: "800"} : {}}
                                      rowSpan={courseIds.length}>
                    {creditXero?.toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                  </td>}
                </tr>
                );
              })}
            </>);
          })()}
        </table>
        <Button onClick={previousPayer}>previous</Button>
        <Button onClick={nextPayer}>next</Button>
        
        {isSuggestSalesRealizationOfBalance && <div>
          {Object.keys(unearnedRevenueByCourseAndMonth).map(cId => <div>
            <Button onClick={() => window.open(`/courses/${cId}/remainingBalances`, "_blank")}>
              Expire balance for {coursesStore.coursesById[cId]?.name}
            </Button> 
          </div>)}
        </div>}
        
        {isSuggestSalesRealizationOfTrial && renderConfirmationDialogForTrialClassSalesRealization()}
        
        {isSuggestTicketCreation && <div>
          CREATE A TICKET TO CONTACT THIS PAYER, SINCE THE UNUSED CREDIT IS SUBSTANTIAL, but there has been no activity since Jan 2025          
        </div>}

        
        <div style={{position: "absolute", bottom: 0}}>
          <Button onClick={() => setShowReconciliationConfirmation(true)}>mark as reconciled</Button>
        </div>

        {isShowReconciliationConfirmation &&
          <ConfirmationDialog
            message={`You're about to mark ${usersStore.getUserById(payerIds[payerIdx])?.name} as reconciled with an accounting balance of ${calculateBalanceRecordedOnReconciliation(unearnedRevenueInAccounting)}. Are you sure??`}
            onConfirm={() => markUserAsReconciled(payerIds[payerIdx], unearnedRevenueInAccounting)}
            onReject={() => {
              setCanceledAutomaticReconciliation(true);
              setShowReconciliationConfirmation(false);
            }}
          />
        }
      </div>
    );
  
    function previousPayer() {
      setPayersIdx(idx => Math.max(idx - 1, 0));
      resetStateForNextPayer()
    }
  
    function nextPayer() {
      setPayersIdx(idx => Math.min(idx + 1, payerIds.length - 1));
      resetStateForNextPayer()
    }
    
    async function markUserAsReconciled(userId, balance) {
      try {
        await courseApi.markUserAsReconciled(userId, calculateBalanceRecordedOnReconciliation(balance), financialYearEndMillis);
        setPayersIds(payerIds => payerIds.toSpliced(payerIdx, 1) );
        resetStateForNextPayer()
      } catch (e) {
        logError("Failed to mark user as reconciled", e);
      }
      setShowReconciliationConfirmation(false);
    }
    
    function calculateBalanceRecordedOnReconciliation(balance) {
      const roundedBalance = Math.round(balance * 100) / 100;
      return (Math.abs(roundedBalance) < 0.05) ? 0 : roundedBalance;
    }
    
    function resetStateForNextPayer() {
      setUnearnedRevenueByCourseAndMonth({});
      setUnearnedRevenueInAccounting(undefined);
      setSuggestSalesRealizationOfBalance(false);
      setSuggestTicketCreation(false);
      setCanceledAutomaticReconciliation(false);      
      setSuggestSalesRealizationOfTrial(false);
    }
    
    function renderConfirmationDialogForTrialClassSalesRealization() {
      const payerId = payerIds[payerIdx];
      const course = coursesStore.coursesById[courseIdOfFreeTrial];
      const {consumedCreditPerPayerStudentAndMonth, consumedHoursPerPayerStudentAndMonth} = course.earnedRevenuesPerMonth;
      const courseName = course.name;
      const salesEntries = [];
      let timestamp;
      for (let stId in consumedHoursPerPayerStudentAndMonth[payerId]) {
        const amount = consumedCreditPerPayerStudentAndMonth[payerId][stId][monthIdxOfTrial];
        console.log("consumedCreditPerPayerStudentAndMonth[payerId][stId]", consumedCreditPerPayerStudentAndMonth[payerId][stId]);
        console.log(monthIdxOfTrial, monthIdxOfTrial);
        const numHours = consumedHoursPerPayerStudentAndMonth[payerId][stId][monthIdxOfTrial];
        const firstPurchaseForStudent = course.purchasesByStudentId[stId].sort((p1, p2) => p1.creationTime - p2.creationTime).filter(p => p.price > 0)[0];
        if (!firstPurchaseForStudent) return;
        const currency = firstPurchaseForStudent.currency;
        timestamp = firstPurchaseForStudent.creationTime;   //Obviously we have a problem if the parents paid for the kids classes separately, on different dates (months!?) and both took trials before. Then the date will be wrong
        
        salesEntries.push({
          amount,
          numHours,
          currency,
          payerId,
          studentId: stId,
          invoiceXRate: 1,  //we're passing the amount directly in SGD. The currency only affects the unearned revenue account the money is taken from
          courseName
        });
      }
      return (
        <ConfirmationDialog
          message={`You're about to realize sales ${JSON.stringify(salesEntries)} on date ${moment(timestamp).format("DD-MM-YYYY")}. Are you sure??`}
          onConfirm={async () => {
            await accountingApi.realizeSales(salesEntries, timestamp);
            nextPayer();
          }}
          onReject={() => {
            setSuggestSalesRealizationOfTrial(false);
          }}
        />
      );
      
    }
  }
);

function findMonthForFirstPositiveValue(valuesByCourseId) {
  let monthOfFirstPositiveValue = 999;
  let cIdOfFirstPositiveValue = null;
  Object.entries(valuesByCourseId).forEach(([cId, crsValues]) => {
    for (let i in crsValues) {
      if (crsValues[i] > 0) {
        if (i < monthOfFirstPositiveValue) {
          monthOfFirstPositiveValue = i;
          cIdOfFirstPositiveValue = cId;
        }
        break
      }
    }
  });
  return [monthOfFirstPositiveValue, cIdOfFirstPositiveValue];
}

